export default __webpack_public_path__ + "static/banner-ea19ceec994be7e7c470532c15004e75.png";